import React from 'react'
import { Link } from 'react-router-dom'
import './FooterExLinkCardQuickLink.css'

const FooterExLinkCardQuickLink = ({  item, path }) => {
    return (
        <li className="FooterExLinkCardQuickLink"><Link to={path}>{item}</Link></li>
    )
}

export default FooterExLinkCardQuickLink
